module.exports = __webpack_public_path__ + "media/images/icons/clock-light-1dedea3fc517254ace423337294a9aa6.svg";